import type { ThemeVariantMap } from "@/theme/types";

import { blenderLightTheme } from "./blender.light";

export const blenderTheme: ThemeVariantMap = {
  LIGHT: blenderLightTheme,
} as const;
